import React from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';
import Confirmation from './Confirmation';
import { SFEntityID } from 'utils/types';

export default class ConfirmationView extends React.Component {

  render() {
    const { hasFetched, ...props } = this.props;
    return hasFetched
      ? <Confirmation {...props} />
      : <div><Loader active inline='centered'>Loading appointment...</Loader></div>;
  }
}

ConfirmationView.propTypes = {
  appointmentId: SFEntityID,
  hasFetched: PropTypes.bool.isRequired,
  startDate: PropTypes.object,
  duration: PropTypes.number,
  locationName: PropTypes.string,
  instructions: PropTypes.string,
  reasonName: PropTypes.string,
  displayTeamMember: PropTypes.bool,
  ownerName: PropTypes.string,
  ownerTitle: PropTypes.string,
  ownerPhotoURL: PropTypes.string,
  recurring: PropTypes.bool,
  recurrenceLabel: PropTypes.string,
  recurrenceEndDate: PropTypes.object,
  courseName: PropTypes.string,
  studentNote: PropTypes.string,
  scheduleBlockInstructions: PropTypes.string,
  participants: PropTypes.array
};
